import Vue from 'vue'
import SuiVue from 'semantic-ui-vue';

import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

import 'semantic-ui-css/semantic.min.css';
import './styles/index.scss'

Vue.config.productionTip = false
Vue.use(SuiVue);
Vue.use(require('vue-moment'));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
